import './styles.scss';

import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

const Input = ({
	className,
	type,
	id,
	name,
	label,
	placeholder,
	value,
	onInputChange,
	error,
	...otherProps
}) => {
	const defaultProps = {
		id,
		name,
		placeholder,
		value,
		onChange: onInputChange,
		className: cx({ 'has-error': !!error }),
	};

	const checkboxLabelProps =
		type === 'checkbox'
			? {
					onMouseEnter: otherProps?.onMouseEnter ?? false,
					onMouseLeave: otherProps?.onMouseLeave ?? false,
					[`data-target`]: true,
			  }
			: {};

	return (
		<div className={cx('input', `input--${type}`, className)}>
			{label && (
				<label
					htmlFor={id}
					dangerouslySetInnerHTML={{ __html: label }}
					{...checkboxLabelProps}
				></label>
			)}
			{type === 'textarea' ? (
				<textarea {...defaultProps} {...otherProps}></textarea>
			) : (
				<input type={type} {...defaultProps} {...otherProps}></input>
			)}
			<p className="input__error">{error}</p>
		</div>
	);
};

Input.propTypes = {
	className: PropTypes.string,
	type: PropTypes.string.isRequired,
	id: PropTypes.string.isRequired,
	name: PropTypes.string,
	label: PropTypes.string,
	placeholder: PropTypes.string,
	value: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.bool,
		PropTypes.number,
	]),
	onInputChange: PropTypes.func,
	error: PropTypes.string,
};

export default Input;
